import { defineRoute } from "../../common/route.common";
import { loadView } from "../../common/view.common";

export const ProfileRoutes = defineRoute({
    home: {
        route: {
            path: "/profile",
            component: () => loadView(import("./ProfileHome.vue")),
        },
    },
});
